export default __webpack_public_path__ + "static/media/fun.ccca17de.jpg";